import Table from "../../../table.component";
import PartsRow from "../row.open.parts.table.component";
import DEFAULT_OPEN_ORDERS_COLUMNS from "../../../../../constants/parts/defaultOpenOrdersColumns";

const SelectedPartsTable = ({ data = [], select = false }) => {
  return (
    <Table columns={DEFAULT_OPEN_ORDERS_COLUMNS} select={true}>
      {data &&
        data.map((part, index) => (
          <PartsRow
            columns={DEFAULT_OPEN_ORDERS_COLUMNS}
            select={select}
            key={index}
            data={part}
            className={`max-h-[50px] h-[50px] ${
              index % 2 === 0 ? "bg-slate-100" : "bg-gray-300"
            }`}
          />
        ))}
    </Table>
  );
};

export default SelectedPartsTable;
